<template>

	<div class="index-course-center">


		<div class="clearfix index-title-block">
			<div class="pull-left index-title">
				<i class="fa fa-envelope-open-o"></i>
				课程简介
			</div>
			<div class="pull-right index-title-more">
							<span class="nb-a" @click.stop.prevent="$router.push('/'+topic.location+'/introduction')">
								更多
								<i class="fa fa-caret-square-o-right color-main"></i> </span>
			</div>
		</div>
		<div class="text-center" v-show="article.loading">
			<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
		</div>
		<div class="index-content-block" v-html="article.content"></div>

	</div>

</template>


<script>

	import Swiper from "swiper";

	import Carousel from "../../../../../common/model/carousel/Carousel";
	import Person from "../../../../../common/model/person/Person";
	import Article from "../../../../../common/model/article/Article";
	import Pager from "../../../../../common/model/base/Pager";
	import {startWith} from "../../../../../common/filter/str";

	export default {

		props: {},
		data() {
			return {
				personPager: new Pager(Person),
				swiper: null,
				article: new Article()
			};
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		watch: {},
		methods: {

			refresh(){

				let that = this;
				this.personPager.httpFastPage(function () {

					setTimeout(function () {

						that.swiper = new Swiper('.leader-swiper-container', {
							autoplay: 3000,
							speed: 1000,
							// Optional parameters
							direction: 'horizontal',
							loop: true,

							paginationClickable: true,

							slidesPerView: 4,
							spaceBetween: 10
						});
					}, 200);


				})


			}
		},
		mounted(){
			this.refresh();

			this.article.id = 2;
			this.article.httpDetail();
		}
	};
</script>


<style lang="less" rel="stylesheet/less">

	.index-course-center {

		.index-content-block {

			@media (min-width: 1200px) {
				min-height: 307px;
			}
			@media (min-width: 992px) and (max-width: 1200px) {
				min-height: 346px;
			}
		}

	}

</style>



// WEBPACK FOOTER //
// IndexCourseCenter.vue?b89d8fc8